import type { MaturityItemId } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';
import type { MaturityItemState } from '@cobliteam/hooks/src/useBasicValueMaturity/useBasicValueMaturity';
import { type ComponentType, lazy } from 'react';

const DeviceAssociationForm = lazy(() => import('./forms/DeviceAssociationForm'));
const DriverAssociationForm = lazy(() => import('./forms/DriverAssociationForm'));
const DriversForm = lazy(() => import('./forms/DriversForm'));
const GroupsForm = lazy(() => import('./forms/GroupsForm'));
const SpeedForm = lazy(() => import('./forms/SpeedForm'));
const UsersForm = lazy(() => import('./forms/UsersForm'));
const VehiclesForm = lazy(() => import('./forms/VehiclesForm'));

/** The Setup Guide items resolved by a dedicated creation modal (card → form → success). */
export type SetupGuideEntityId = 'users' | 'drivers' | 'vehicles' | 'device-association' | 'driver-association' | 'groups' | 'speed';

export interface SetupGuideEntityFormProps {
  fleetId?: string;
  /** Maturity state of the item — current/target feed the progress Tag; route feeds the shortcut. */
  item: MaturityItemState;
  /** Closes the whole guide (X, Esc, Cancelar). */
  onClose: () => void;
  /** Mutation succeeded — the orchestrator swaps to the success modal. */
  onSuccess: (createdCount: number) => void;
  /** "Configurações avançadas": closes the guide and navigates to the entity's full page. */
  onAdvancedSettings: () => void;
}

/** Registry of the entity creation forms (AE-2443), one per Setup Guide entity id. */
export const SETUP_GUIDE_ENTITY_FORMS: Record<SetupGuideEntityId, ComponentType<SetupGuideEntityFormProps>> = {
  'device-association': DeviceAssociationForm,
  'driver-association': DriverAssociationForm,
  drivers: DriversForm,
  groups: GroupsForm,
  speed: SpeedForm,
  users: UsersForm,
  vehicles: VehiclesForm,
};

export const isSetupGuideEntityId = (id: MaturityItemId | null): id is SetupGuideEntityId => id !== null && id in SETUP_GUIDE_ENTITY_FORMS;
